import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {SearchInputComponent} from '@lib-modules/input/modules/search/search-input/search-input.component';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import {LibInputModule} from '@lib-modules/input/lib-input.module';
import { SearchTeamsComponent } from './search-teams/search-teams.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';
import { SearchComponent } from './search/search.component';

@NgModule({
  declarations: [
    SearchInputComponent,
    SearchTeamsComponent,
    SearchComponent
  ],
  imports: [
    CommonModule,
    LibUtilsPipesModule,
    LibInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatAutocompleteModule,
  ],
  exports: [
    SearchInputComponent,
    SearchTeamsComponent,
    SearchComponent
  ]
})
export class LibSearchInputModule {}
